<template>
  <div class="made-order">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入订单号..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.phone"
                 clearable
                 placeholder="输入手机号..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.title"
                 clearable
                 placeholder="输入定制名称..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.order_status"
                  :style="{'width':'150px'}"
                  placeholder="选择订单状态..."
                  clearable>
            <Option v-for="item in orderStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.pay_status"
                  :style="{'width':'150px'}"
                  placeholder="选择支付状态..."
                  clearable>
            <Option v-for="item in payStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.is_user_made"
                  :style="{'width':'150px'}"
                  placeholder="是否用户定制..."
                  clearable>
            <Option v-for="item in usermadeStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.made_status"
                  :style="{'width':'150px'}"
                  placeholder="选择定制状态..."
                  clearable>
            <Option v-for="item in madeStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.ship_status"
                  :style="{'width':'150px'}"
                  placeholder="选择发货状态..."
                  clearable>
            <Option v-for="item in shipStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.receipt_status"
                  :style="{'width':'150px'}"
                  placeholder="选择收货状态..."
                  clearable>
            <Option v-for="item in recepitStatusList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.pay_name"
                 clearable
                 placeholder="输入支付名称..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.type"
                  :style="{'width':'150px'}"
                  placeholder="选择定制类型..."
                  clearable>
            <Option v-for="item in typeList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      @on-change="changeDate"
                      style="width: 260px"
                      placeholder="下单时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>&nbsp;
          <Button type="success"
                  :loading="exportLoading"
                  @click="exportOrder()">导出订单</Button>&nbsp;
          <Button type="success"
                  @click="showImportModel()">批量发货</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table max-height="600"
           border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"
           class="B2CList"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>

    <!-- 发货弹框 -->
    <Modal v-model="showCreatTypeModal"
           title="发货"
           @on-ok="shipOrder('logisticValidate')"
           :loading="dataloading">
      <Form :model="shipdata"
            ref="logisticValidate"
            :rules="logisticValidate"
            action="javascript:void(0)">
        <FormItem label="请选择快递">
          <Select :label-in-value="true"
                  v-model="shipdata.logistic_id"
                  @on-change="perChange"
                  clearable
                  filterable
                  placeholder="选择快递">
            <Option v-for="item in selectLogistics"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="快递单号"
                  prop="logistics_code">
          <Input v-model="shipdata.logistics_code"
                 placeholder />
        </FormItem>
        <FormItem label="商家备注"
                  prop="shop_mark">
          <Input v-model="shipdata.shop_mark"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
    <!-- 发货弹框 end -->
    <!-- 定制 BEGIN-->
    <Modal v-model="showMakeTypeModal"
           title="定制"
           @on-ok="makeOrder('makedataValidate')"
           :loading="dataloading">
      <Form :model="makedata"
            ref="makedataValidate"
            :rules="makedataValidate"
            action="javascript:void(0)">
        <FormItem label="状态">
          <Select :label-in-value="true"
                  v-model="makedata.status"
                  clearable
                  filterable
                  placeholder="状态">
            <Option :value="1"
                    :key="1">定制中</Option>
            <Option :value="2"
                    :key="2">完成</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <!-- 定制 end -->
    <!-- 批量发货的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importCar()"
           :loading="exportLoading">
      <Form :model="leadIn"
            action="javascript:void(0)">
        <FormItem label="选择文件">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileListThree" ref="import-filesThree"></upload-question>-->
          <file-import v-model="leadIn.file_url"
                       :defaultList="fileListThree"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
    <!-- 订单快照弹层 start-->
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <List>
        <ListItem>
          <Row :gutter="16">
            <Col span="6">
            <span style="font-size: 14px;font-weight: bold">定制名称:</span>
            {{detaildata.made_title }}
            </Col>
            <Col span="6">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">分类名称:</span>
              {{detaildata.made_cate_title }}
            </label>
            </Col>
            <Col span="6">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">价格区间:</span>
              {{detaildata.price_range }}
            </label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">封面图:</span>
            </label>
            <img :src="detaildata.thumb"
                 style="width: 200px;height: 200px;" />
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">图集:</span>
            </label>
            <div v-if="detaildata.album!=null&&detaildata.album!=''">
              <img v-for="(item,key) in detaildata.album.split(',')"
                   :src="$publicData.ossUrl+item"
                   style="width: 200px;height: 200px;" />
              <!--<Avatar v-for="(item,key) in detaildata.album.split(',')" shape="square" icon="ios-person" size="large" :src="item"/>-->
            </div>
            </Col>
          </Row>
        </ListItem>

        <ListItem>
          <Row :gutter="16">
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">商品单价:</span>
              {{detaildata.price }}
            </label>
            </Col>
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">划线价格:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.underline_price"></label>
            </Col>
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">制作周期:</span>
              {{detaildata.made_cycle }}
            </label>
            </Col>
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">支付类型:</span>
              {{detaildata.pay_type }}
            </label>
            </Col>
            <Col span="12">
            <label style="font-size: 14px;">
              <span style="font-size: 14px;font-weight: bold">定制周期:</span>
              {{detaildata.order_cycle }}
            </label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">商品内容:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.content"></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">商品描述:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.descript"></label>
            </Col>
          </Row>
        </ListItem>
        <ListItem>
          <Row :gutter="16">

            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">订购量:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.accept_order_count"></label>
            </Col>
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">已经成交数量:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.order_count"></label>
            </Col>
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">虚拟数据:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.false_data"></label>
            </Col>
            <Col span="24">
            <span style="font-size: 14px;font-weight: bold">截止时间:</span>
            <label style="font-size: 14px;"
                   v-html="detaildata.end_at"></label>
            </Col>
          </Row>
        </ListItem>
      </List>
    </Drawer>
    <!-- 订单快照弹层 end -->
  </div>
</template>

<script>
import FileImport from "../common/fileimport";
import expandRow from "./table-expand";

export default {
  name: "made-order",
  data () {
    const validatelogistics_code = (rule, value, callback) => {
      if (this.shipdata.logistics_code === "") {
        callback(new Error("快递单号必须填写"));
      } else {
        callback();
      }
    };
    const validateshopmark = (rule, value, callback) => {
      if (this.shipdata.shop_mark === "") {
        callback(new Error("商家备注必须填写"));
      } else {
        callback();
      }
    };
    return {
      showImportModalStatus: false,
      fileListThree: [],
      detaildata: [],
      modal1: false,
      leadIn: {},
      exportLoading: false,
      orderStatusList: [
        { value: 1, label: "正常" },
        { value: 2, label: "完成" },
        { value: 0, label: "关闭" }
      ],
      payStatusList: [
        { value: 0, label: "未支付" },
        { value: 1, label: "支付中" },
        { value: 2, label: "定金支付完成" },
        { value: 3, label: "尾款支付完成" }
      ],
      usermadeStatusList: [
        { value: 0, label: "否" },
        { value: 1, label: "是" },
      ],
      madeStatusList: [
        { value: 1, label: "定制中" },
        { value: 2, label: "完成" }
      ],
      shipStatusList: [
        { value: 0, label: "未发货" },
        { value: 1, label: "发货" }
      ],
      recepitStatusList: [
        { value: 0, label: "未确认收货" },
        { value: 1, label: "确认收货" }
      ],
      typeList: [
        { value: 1, label: "商家定制" },
        { value: 2, label: "用户定制" }
      ],
      dataloading: true,
      selectLogistics: [],
      showMakeTypeModal: false,
      showCreatTypeModal: false,
      statusList: [
        { id: 1, name: "通过" },
        { id: 0, name: "待审核" },
        { id: -1, name: "不通过" }
      ],
      formItem: {
        key: "",
        phone: "",
        title: "",
        order_status: -1,
        pay_status: -1,
        made_status: -1,
        ship_status: -1,
        receipt_status: -1,
        is_user_made: -1,
        pay_name: "",
        type: 0,
        datetime: []
      },
      loginst: [],
      shipdata: {
        logistic_id: 0,
        logistics_code: "",
        logistics_name: ""
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "",
          type: "expand",
          width: 30,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                _expanded: true,
                row: params.row.payorder
              }
            });
          }
        },
        {
          title: "订单号",
          key: "order_num",
          width: 185
          // fixed:"left"
        },
        {
          title: "定制名称",
          width: 185,
          render: (h, params) => {
            return h(
              "span",
              params.row.type == 1
                ? params.row.made
                  ? params.row.made.title
                  : ""
                : params.row.customizedcommunity.title
            );
          }
        },
        {
          title: "类型",
          width: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h("div", params.row.type == "1" ? "商家发布" : "用户发布");
          }
        },
        {
          title: "会员名",
          width: 185,
          render: (h, params) => {
            return h(
              "span",
              params.row.userdata != null ? params.row.userdata.username : ""
            );
          }
        },
        // {
        //   title: "邮费",
        //   width: 100,
        //   align: "center",
        //   key: "fare"
        // },
        {
          title: "定制价格",
          width: 100,
          key: "price"
        },
        {
          title: "原定制价格",
          width: 100,
          key: "old_price"
        },
        {
          title: "定制数量",
          width: 100,
          key: "num"
        },
        {
          title: "应付款（元）",
          width: 100,
          key: "total_prices"
        },
        {
          title: "支付方式",
          width: 150,
          align: "center",
          key: "pay_type",
          render: (h, params) => {
            return h("div", params.row.pay_type == "1" ? "分批" : "全额");
          }
        },
        {
          title: "定金",
          width: 100,
          key: "deposit"
        },
        {
          title: "尾款",
          width: 100,
          key: "final_payment"
        },
        // {
        //   title: "付款方式",
        //   width: 150,
        //   align: "center",
        //   key: "pay_name"
        // },
        {
          title: "支付状态",
          width: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                  ? "支付中"
                  : params.row.pay_status == "2"
                    ? "待付尾款"
                    : "已完成"
            );
          }
        },
        {
          title: "收货人姓名",
          key: "person",
          width: 150,
          tooltip: true
        },
        {
          title: "收货人手机号",
          key: "phone",
          width: 150,
          tooltip: true
        },
        {
          title: "收货地址",
          key: "address",
          width: 220,
          tooltip: true
        },
        // {
        //   title: "支付方式",
        //   width: 150,
        //   align: "center",
        //   key: "pay_name"
        // },
        {
          title: "发货状态",
          width: 100,
          align: "center",
          key: "ship_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.ship_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.ship_status == "1" ? "已发货" : "未发货"
            );
          }
        },
        {
          title: "快递名称",
          key: "logistics_name",
          width: 150,
          tooltip: true
        },
        {
          title: "快递单号",
          key: "logistics_code",
          width: 150,
          tooltip: true
        },
        {
          title: "收货状态",
          width: 100,
          align: "center",
          key: "receipt_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.receipt_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.receipt_status == "1" ? "已收货" : "未收货"
            );
          }
        },
        {
          title: "订单状态",
          width: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.order_status == "0"
                      ? "red"
                      : params.row.order_status == "1"
                        ? "orange"
                        : "geekblue"
                }
              },
              params.row.order_status == "0"
                ? "关闭"
                : params.row.order_status == "1"
                  ? "正常"
                  : "完成"
            );
          }
        },
        // {
        //     title: '邮寄方式',
        //     minWidth: 100,
        //     align: "center",
        //     key: 'fare_type',
        //     render: (h, params) => {
        //         // return h('div', params.row.fare_type == "1" ? '自提' : '邮寄')
        //         return h('tag',
        //             {
        //                 props: {
        //                     color: params.row.fare_type == "1" ?'geekblue':'red',
        //                 }
        //             },
        //             params.row.fare_type == "1" ? '自提' : '邮寄')
        //     }
        // },

        {
          title: "下单时间",
          minWidth: 150,
          key: "created_at"
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 250,
          // fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "1" &&
                        params.row.pay_status != 3
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.cancelorder(params.row.id);
                    }
                  }
                },
                "取消"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "1" &&
                        (params.row.pay_status == "2" ||
                          params.row.pay_status == "3") &&
                        params.row.made_status == 1
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.make(params.row.id);
                    }
                  }
                },
                "定制"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.order_status == "1" &&
                        params.row.pay_status == "3" &&
                        params.row.ship_status == "0" &&
                        params.row.made_status == 2
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.ship(params.row.id);
                    }
                  }
                },
                "发货"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.is_orderphoto > 0
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.showOrderPhoto(params.row.id);
                    }
                  }
                },
                "订单快照"
              ),
            ]);
          }
        }
      ],
      tablelist: [],
      datagood: [],
      logistics_id: 0,
      logisticValidate: {
        logistics_code: [
          { required: true, validator: validatelogistics_code, trigger: "blur" }
        ],
        shop_mark: [
          { required: true, validator: validateshopmark, trigger: "blur" }
        ]
      },
      makedata: {
        status: 1
      },
      makedataValidate: {}
    };
  },
  // 计算
  components: {
    FileImport,
    expandRow
  },
  mounted: function () {
    // 取数据
    this.getTableList();
    //取快递数据
    this.getLogisticList();
  },
  methods: {
    // 获取订单列表
    getTableList: function () {
      var params = {
        is_platprice: this.is_platprice,
        page: this.pages.current,
        size: this.pages.size
      };
      this.$api.madeorder.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          for (var i = 0; i < 10; i++) {
            this.tablelist[i]._expanded = true;
          }
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changeDate (val) {
      this.formItem.datetime = val;
    },
    //获取快递列表
    getLogisticList () {
      var params = {
        page: 1,
        size: 10000
      };
      this.$api.logistics.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.selectLogistics = res.result.list;
        }
      });
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    ship: function (index) {
      this.shipdata.logistic_id = 0;
      this.shipdata.shop_mark = "";
      this.shipdata.logistics_code = "";
      this.id = index;
      this.showCreatTypeModal = true;
    },
    exportOrder () {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        key: this.formItem.key,
        phone: this.formItem.phone,
        title: this.formItem.title,
        order_status: this.formItem.order_status,
        pay_status: this.formItem.pay_status,
        made_status: this.formItem.made_status,
        ship_status: this.formItem.ship_status,
        receipt_status: this.formItem.receipt_status,
        pay_name: this.formItem.pay_name,
        type: this.formItem.type,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.madeorder.customizedOrder(params).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          // window.location.href = res.result;
        }
        this.exportLoading = false;
      });
    },
    //定制
    make: function (index) {
      this.id = index;
      this.makedata = {
        status: 1
      };
      this.showMakeTypeModal = true;
    },
    makeOrder: function (name) {
      // this.$refs[name].validate(valid => {
      // if (valid) {
      let params = {
        id: this.id,
        status: this.makedata.status
      };
      this.$api.madeorder.make(params).then(res => {
        if (res.code == 200) {
          this.showMakeTypeModal = false;
          this.getTableList();
        }
      });
      this.dataloading = false;
      this.$nextTick(() => {
        this.dataloading = true;
      });
      // } else {
      //     console.log(222);
      //     this.showMakeTypeModal = true;
      //     this.$Message.error("请检查输入的信息是否正确！");
      //     this.dataloading = false;
      //     this.$nextTick(() => {
      //         this.dataloading = true;
      //     });
      // }
      // });
    },
    cancelorder: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.madeorder.cancel({ id: index }).then(res => {
            if (res.code == 200) {
              this.renderTable(1);
            }
          });
        }
      });
    },
    perChange: function (index) {
      if (index) {
        this.shipdata.logistics_name = index.label;
      }
    },
    shipOrder: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            id: this.id,
            logistics_id: this.shipdata.logistics_id,
            shop_mark: this.shipdata.shop_mark, // 备注
            logistics_name: this.shipdata.logistics_name,
            logistics_code: this.shipdata.logistics_code // 快递单号
          };

          this.$api.madeorder.ship(params).then(res => {
            if (res.code == 200) {
              this.showCreatTypeModal = false;
              this.getTableList();
            }
          });
          this.dataloading = false;
          this.$nextTick(() => {
            this.dataloading = true;
          });
        } else {
          this.showCreatTypeModal = true;
          this.$Message.error("请检查输入的信息是否正确！");
          this.dataloading = false;
          this.$nextTick(() => {
            this.dataloading = true;
          });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        phone: this.formItem.phone,
        title: this.formItem.title,
        order_status: this.formItem.order_status,
        pay_status: this.formItem.pay_status,
        made_status: this.formItem.made_status,
        is_user_made: this.formItem.is_user_made,
        ship_status: this.formItem.ship_status,
        receipt_status: this.formItem.receipt_status,
        pay_name: this.formItem.pay_name,
        type: this.formItem.type,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.madeorder.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          for (var i = 0; i < 10; i++) {
            this.tablelist[i]._expanded = true;
          }
          this.$Message.success(res.msg);
        }
      });
    },
    // 导入
    showImportModel: function () {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.file_url = "";
    },
    importCar (name) {
      if (
        this.$refs["import-filesThree"].resList != undefined &&
        this.$refs["import-filesThree"].resList.length
      ) {
        this.leadIn.file_url = this.$refs["import-filesThree"].resList[0].url;
      } else {
        this.leadIn.file_url = "";
        this.$Message.error("请选择上传文件");
        this.dataloading = false;
        this.$nextTick(() => {
          this.dataloading = true;
        });
        return;
      }
      this.$api.madeorder.allship(this.leadIn).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.showImportModalStatus = false;
          this.renderTable(1);
        }
      });
    },
    // 查看详情
    showOrderPhoto: function (order_id) {
      this.modal1 = true;
      this.$api.madeorder.photo({ order_id: order_id }).then(res => {
        if (res.code == 200) {
          this.detaildata = res.result;
        }
      });
      return;
    },
  }
};
</script>

<style scoped>
</style>